import axios, { AxiosError, AxiosResponse } from "axios";

/**
 * An Axios request wrapper. If the request generates an AxiosError, the error
 * will be caught and its contents returned to the caller.
 *
 * @param callback A callback for an Axios request.
 * @returns A promise for an Axios response.
 */
export const axiosSafeRequest = async (callback: () => Promise<AxiosResponse | undefined>): Promise<AxiosResponse | undefined> => {
  try {
    return await callback();
  }
  catch (error) {
    if (axios.isAxiosError(error)) {
      return (error as AxiosError).response;
    }
  }
}
